var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.066 18.756L15.31 12L22.066 5.24404C22.1955 5.11301 22.2681 4.93623 22.2681 4.75204C22.2681 4.56784 22.1955 4.39106 22.066 4.26004L18.875 1.06804C18.744 0.93857 18.5672 0.865967 18.383 0.865967C18.1988 0.865967 18.0221 0.93857 17.891 1.06804L11.135 7.82404L4.37904 1.06804C4.24802 0.93857 4.07124 0.865967 3.88704 0.865967C3.70285 0.865967 3.52607 0.93857 3.39504 1.06804L0.203045 4.26004C0.0735794 4.39106 0.000976562 4.56784 0.000976562 4.75204C0.000976562 4.93623 0.0735794 5.11301 0.203045 5.24404L6.95904 12L0.203045 18.756C0.0735794 18.8871 0.000976562 19.0638 0.000976562 19.248C0.000976563 19.4322 0.0735794 19.609 0.203045 19.74L3.39404 22.931C3.52507 23.0605 3.70185 23.1331 3.88604 23.1331C4.07024 23.1331 4.24702 23.0605 4.37804 22.931L11.134 16.175L17.89 22.931C18.0211 23.0605 18.1978 23.1331 18.382 23.1331C18.5662 23.1331 18.743 23.0605 18.874 22.931L22.066 19.737C22.1955 19.606 22.2681 19.4292 22.2681 19.245C22.2681 19.0608 22.1955 18.8841 22.066 18.753V18.756Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.89539710.svg";
export { ForwardRef as ReactComponent };